import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=c54f743a&"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts&"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports